import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";

import type { PopoverTriggerProps } from "./Popover.types";

export function PopoverTrigger<Payload = unknown>({
  ...props
}: PopoverTriggerProps<Payload>): JSX.Element {
  return <BasePopover.Trigger data-slot="popover-trigger" {...props} />;
}
